import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddonModule } from 'src/app/shared/modules/addon/addon.module';
import { LicenseModule } from 'src/app/shared/modules/license/license.module';
import { LicenseDetailsComponent } from './license-details.component';
import { AccountLicenseRoutingModule } from './account-license.routing.module';
import { LicenseUsageComponent } from './license-usage/license-usage.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
 imports: [
     CommonModule,
     AddonModule,
     LicenseModule,
     AccountLicenseRoutingModule,
     MatSlideToggleModule,
 ],
 declarations: [LicenseDetailsComponent,
      LicenseUsageComponent],
 exports: [LicenseDetailsComponent,
        LicenseUsageComponent]

})
export class AccountLicenseModule {

}